import { Component, ElementRef, ViewChild } from '@angular/core';
import { IDateAngularComp } from 'ag-grid-angular';
import { IDateParams } from 'ag-grid-community';

// https://plnkr.co/edit/Bsa33tK3mOVWOJpv?preview

@Component({
  selector: 'app-ag-grid-datetime',
  template: `
    <div #nativePickerEl class="ag-input-wrapper custom-date-filter" role="presentation">
      <input [(ngModel)]="picker" (ngModelChange)="onDateChanged($event)" type="datetime-local" #eInput data-input />
    </div>
  `,
  styles: [
    `
      .custom-date-filter a {
        position: absolute;
        right: 20px;
        color: rgba(0, 0, 0, 0.54);
        cursor: pointer;
      }

      .custom-date-filter input {
        width: 100%;
      }
    `,
  ],
  standalone: false,
})
export class AgGridDatetimeComponent implements IDateAngularComp {
  @ViewChild('nativePickerEl', { read: ElementRef })
  nativePickerEl!: ElementRef;

  @ViewChild('eInput', { read: ElementRef }) eInput!: ElementRef;

  private date: Date = null;
  private params: IDateParams;
  public picker;

  agInit(params: IDateParams): void {
    this.params = params;
  }

  onDateChanged(selectedDates) {
    this.date = selectedDates || null;
    this.params.onDateChanged();
  }

  getDate(): Date {
    const res = this.date ? new Date(this.date) : null;
    return res;
  }

  setDate(date: Date): void {
    this.date = date || null;
    this.picker = date;
  }

  setInputPlaceholder(placeholder: string): void {
    this.eInput.nativeElement.setAttribute('placeholder', placeholder);
  }

  setInputAriaLabel(label: string): void {
    this.eInput.nativeElement.setAttribute('aria-label', label);
  }
}
